import PropTypes from 'prop-types'

const Tooltip = (props) => {
  const { content, modifiers } = props
  const modifierClasses = modifiers ? ' ' + modifiers.join(' ') : ''

  return (
    <span className={`Tooltip${modifierClasses}`}>
      <span className="Tooltip-inner">
        <span className="Tooltip-content">{content}</span>
        <span className="Tooltip-pointer"></span>
      </span>
    </span>
  )
}

Tooltip.propTypes = {
  content: PropTypes.string.isRequired,
  modifiers: PropTypes.array
}

export default Tooltip
